import { EMPTY, Observable, defer, merge, of, timer } from 'rxjs';
import { catchError, exhaustMap, timeout } from 'rxjs/operators';
import { OVERVIEW_POLL_MS } from './orchestration-overview.util';

export const MONITORING_REQUEST_TIMEOUT_MS = 30_000;

/** Polls independently, skips busy refreshes, and aborts timed-out reads without ending polling. */
export function pollMonitoring<T>(
  request: () => Observable<T>,
  refresh$: Observable<unknown> = EMPTY,
): Observable<T | null> {
  return merge(timer(0, OVERVIEW_POLL_MS), refresh$).pipe(
    exhaustMap(() => defer(request).pipe(
      timeout({ first: MONITORING_REQUEST_TIMEOUT_MS }),
      catchError(() => of(null)),
    )),
  );
}
